import { createSlice } from "@reduxjs/toolkit";
import { IStudentGradeDetailSlice } from "../../../models/student/studentGradeDetail";



const InitialStudentGradeDetails: IStudentGradeDetailSlice = {
    gradeDetail: undefined,
  };
  
  const studentGradeDetailSlice = createSlice({
    name: "studentGradeDetailSlice",
    initialState: InitialStudentGradeDetails,
    reducers: {
      setStudentGradeDetail: (state, action: { payload: any }) => {
        state.gradeDetail = action.payload;
      },
    },
  });
  
  export const { setStudentGradeDetail } = studentGradeDetailSlice.actions;
  
  
  const studentGradeDetailReducer = studentGradeDetailSlice.reducer;
  
  export type studentCourceDetailState = ReturnType<typeof studentGradeDetailReducer>;
  
  export default studentGradeDetailReducer;
  